import React from 'react';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from '../../connect';
import { rateItem } from '../../actions';
import { ItemRating } from '../item-rating';
import './index.less';
import { IActionDispatch } from '../../actions/action-types';

function mapDispatchToProps(dispatch) {
	return { dispatch };
}

function mapStateToProps({ item }) {
	return { item };
}

interface IRatingOverlayProps {
	dispatch?: IActionDispatch;
	ratingItemId: string;
	ratingItemTitle?: string;
	returnUrl?: string;
	isEmbedded?: boolean;
	hideRating: () => void;
	isKidsMode?: boolean;
}

interface IRatingOverlayState {
	userRating?: number;
	shareButtonClass: string;
	hideRating: boolean;
}

@connect(mapStateToProps, mapDispatchToProps)
export class RatingOverlay extends React.Component<IRatingOverlayProps, IRatingOverlayState> {
	static contextTypes = {
		router: PropTypes.object.isRequired,
	};

	state: IRatingOverlayState = {
		shareButtonClass: 'share-inactive',
		hideRating: false,
	};

	_handlePostToGroup() {
		const { dispatch, ratingItemId, returnUrl } = this.props;
		const { userRating } = this.state;
		if (userRating && dispatch) {
			dispatch(
				rateItem({
					itemId: ratingItemId,
					rating: userRating,
					shareToFaithlife: true,
				})
			);
			this.context.router.history.push(returnUrl && returnUrl.length ? returnUrl : '/');
		}
	}

	_handleCloseButton() {
		this.props.hideRating();
	}

	render() {
		const { returnUrl, isKidsMode, isEmbedded, ratingItemId, ratingItemTitle, dispatch } = this.props;

		return (
			<div className="rating-overlay container">
				{/* TODO: Fix this the next time the file is edited. */}
				{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
				<div className="close-button" onClick={() => this._handleCloseButton()}>
					&#x2A09;
				</div>
				<div className="ratings">
					<h2>Rate this title</h2>
					<ItemRating
						isAuthenticated // assume this component is only shown to authenticated users
						canRate
						hideInitialRating={true}
						disableRatingText={true}
						itemId={ratingItemId}
						itemTitle={ratingItemTitle}
						dispatch={dispatch}
						onItemRated={userRating => this.setState({ userRating, shareButtonClass: 'share-active' })}
					/>
				</div>
				{isEmbedded
					? false
					: [
							<div key="1">
								<button
									className={isKidsMode ? 'share-hidden' : this.state.shareButtonClass}
									onClick={() => this._handlePostToGroup()}
								>
									{'Share now to Faithlife group'}
								</button>
							</div>,
							<Link key="2" to={returnUrl && returnUrl.length ? returnUrl : '/'}>
								<button>Back to browse</button>
							</Link>,
					  ]}
			</div>
		);
	}
}
